module.exports = __webpack_public_path__ + "img/fuel-station-pump.a9c8c0b0.png";